import { render } from "./XTabNode.vue?vue&type=template&id=fab4ec06&scoped=true"
import script from "./XTabNode.vue?vue&type=script&lang=js"
export * from "./XTabNode.vue?vue&type=script&lang=js"

import "./XTabNode.vue?vue&type=style&index=0&id=fab4ec06&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab4ec06"]])

export default __exports__